import Borrow from '../../views/borrows/Index'
import { applicantRouters } from './applicant'
import { draftRouters } from './draft'
import { clientRouters } from './client'
import { rejectRouters } from './reject'
import { trashedRouters } from './trashed'
import { cancelRouters } from '@/routers/borrows/cancel'

export const borrowRouters = {
  path: 'borrow',
  name: 'borrow',
  component: Borrow,
  children: [
    applicantRouters,
    draftRouters,
    clientRouters,
    rejectRouters,
    trashedRouters,
    cancelRouters
  ]
}
